// extracted by mini-css-extract-plugin
export default {"search-bar":"ProductsHeader_search-bar__mflTk","header-filters":"ProductsHeader_header-filters__gEGWq"};